import Store from '../Store';

const SupplierListStore = new Store('supplier');

export default SupplierListStore;